<script setup lang="ts">
import SearchList from '@pages/search/components/SearchList.vue';
import SearchMapSection from '@pages/search/components/SearchMapSection.vue';
import SearchFilters from '@pages/search/components/SearchFilters.vue';
import { storeToRefs } from 'pinia';
import { useSearchStore } from '@stores/useSearchStore.ts';
import { useFilterStore } from '@stores/useFilterStore.ts';
import { useScreensizeStore } from '@stores/useScreensizeStore.ts';
import SearchStickyActions from '@pages/search/components/SearchStickyActions.vue';

const { mapIsVisible } = storeToRefs(useSearchStore());
const { isFilterOpen } = storeToRefs(useFilterStore());
const { isMobileOrTablet } = storeToRefs(useScreensizeStore());
</script>

<template>
  <div>
    <div
      v-if="isFilterOpen"
      class="fixed inset-0 z-10 hidden bg-black/50 lg:block"
    />

    <SearchFilters class="w-full" />

    <div
      :class="[
        'px-6',
        'flex gap-x-6'
      ]"
    >
      <SearchList />

      <SearchMapSection
        v-if="mapIsVisible || isMobileOrTablet"
        class="absolute flex-1 lg:static"
      />
    </div>

    <SearchStickyActions />
  </div>
</template>
